/* 调用原生方法
 * @param stringJson
 * 传入参数示例
 *  {
        "pageType":"exam", 跳转指定页面 exam原生考试页面
        "data":{   携带参数
            "tid":num,  计划id
            "rid":num,  资源id
            "cid":num  小节id
        }
    }
 * */

let common = {
  methods: {
    sendMessageToNative(stringJson) {
      // 判断客户端类型调用指定方法
      stringJson = JSON.stringify(stringJson);
      let uagent = window.navigator.userAgent;
      let isAndroid =
        uagent.indexOf("Android") > -1 || uagent.indexOf("Adr") > -1;
      // IOS
      let isiOS = !!uagent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        // iphone
        window.webkit.messageHandlers.jsToSwift.postMessage(stringJson);
      }
      if (isAndroid) {
        // andriod
        Android.jumpToPage(stringJson);
      }
    },
  },
};

export default common;
